(() => {
  const blockIdPart = 'judge_me_reviews_cards_carousel_WfXyej';
  const desktopQuery = window.matchMedia('(min-width: 1350px)');

  const initialize = () => {
    const block = document.querySelector(`[id$='__${blockIdPart}']`);
    const widget = block?.querySelector('.jdgm-cards-carousel');
    const wrapper = widget?.querySelector('.jdgm-cards-wrapper');
    const track = wrapper?.querySelector('.jdgm-videos-container');
    const firstCard = track?.querySelector('.jdgm-carousel-item');

    if (!widget || !wrapper || !track || !firstCard || widget.dataset.asSevenReviewsReady === 'true') {
      return false;
    }

    const originalCards = [...track.querySelectorAll(
      '.jdgm-carousel-item:not(.jdgm-clone-before):not(.jdgm-clone-after)',
    )];
    const clonesBefore = track.querySelectorAll('.jdgm-clone-before').length;

    if (originalCards.length < 7 || clonesBefore === 0) return false;

    widget.dataset.asSevenReviewsReady = 'true';

    const originalTransform = track.style.transform;
    let pageStart = 0;

    const move = () => {
      if (!desktopQuery.matches) return;

      const gap = Number.parseFloat(getComputedStyle(track).gap) || 20;
      const step = firstCard.getBoundingClientRect().width + gap;
      track.style.transform = `translateX(-${(clonesBefore + pageStart) * step}px)`;
    };

    const moveNext = () => {
      pageStart = pageStart >= originalCards.length - 7
        ? 0
        : Math.min(pageStart + 7, originalCards.length - 7);
      move();
    };

    const movePrevious = () => {
      pageStart = pageStart <= 0
        ? Math.max(0, originalCards.length - 7)
        : Math.max(0, pageStart - 7);
      move();
    };

    block.addEventListener('click', (event) => {
      if (!desktopQuery.matches) return;

      const button = event.target.closest('.jdgm-content > .jdgm-arrow');
      if (!button || !block.contains(button)) return;

      const arrows = [...widget.querySelectorAll('.jdgm-content > .jdgm-arrow')];
      const arrowIndex = arrows.indexOf(button);
      if (arrowIndex < 0) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (arrowIndex === 0) {
        movePrevious();
      } else {
        moveNext();
      }
    }, true);

    const handleViewportChange = () => {
      if (desktopQuery.matches) {
        requestAnimationFrame(move);
      } else {
        pageStart = 0;
        track.style.transform = originalTransform;
      }
    };

    desktopQuery.addEventListener('change', handleViewportChange);
    window.addEventListener('resize', () => requestAnimationFrame(handleViewportChange), { passive: true });
    requestAnimationFrame(move);

    return true;
  };

  if (!initialize()) {
    const observer = new MutationObserver(() => {
      if (initialize()) observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
